export default __webpack_public_path__ + "static/media/derekImage.1cda4b09.png";